import 'vue-awesome/icons/wifi';
import 'vue-awesome/icons/ban';
import offlineCheck from '@/mixins/offline-check';

export default {
  mixins: [offlineCheck],
};



// WEBPACK FOOTER //
// ./src/components/offline-button/OfflineButton.js